import React from "react";
import { IconButton } from "../../designSystem";

/** 分页控件：上一页 · 第 x / n 页 · 下一页 */
export default function Pager({ page, totalPages, onChange }) {
  if (!totalPages || totalPages <= 1) return null;
  return (
    <div className="lt-pager">
      <IconButton
        icon="chevron_left"
        label="上一页"
        variant="outline"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      />
      <span className="lt-pager__info">
        第 {page} / {totalPages} 页
      </span>
      <IconButton
        icon="chevron_right"
        label="下一页"
        variant="outline"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
      />
    </div>
  );
}
